var map = {
	"./Academy/sidebar-links.js": "02f3",
	"./Actionsboard/sidebar-links.js": "ed79",
	"./Dev/sidebar-links.js": "cb6d",
	"./Hosting/sidebar-links.js": "61d2",
	"./Marketplace/sidebar-links.js": "17ec",
	"./Orgchart/sidebar-links.js": "554f",
	"./Presence/sidebar-links.js": "547e",
	"./Process/sidebar-links.js": "37ac",
	"./Quest/sidebar-links.js": "69af",
	"./Saas/sidebar-links.js": "d9c8",
	"./Templates/sidebar-links.js": "0f82",
	"./Wiki/sidebar-links.js": "8367"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b36a";